import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { of, Observable } from 'rxjs';
import { SERVER_API_URL } from 'app/app.constants';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) { }

getQuestionsAndAnswers():Observable<any>
{
return this.http.get(SERVER_API_URL + 'api/message_bot')
}
askQuestion(form,id): Observable<any> {
  return this.http.post(SERVER_API_URL + 'api/ask_question', form.value);
}
getMyAnsweredQuestions():Observable<any>
{
  return this.http.get(SERVER_API_URL + 'api/get_my_answered_questions_user')
}
}
